import { t } from 'commons/libs/i18n'
import { Badge, Icon, Modal } from 'components'
import type { SalesCalendarListItem } from 'services/salesCalendar/interfaces'
import { deleteSalesCalendar } from 'store/SalesCalendarContext/salesCalendarSlice'
import { useDispatch } from 'store/store'

export type CalendarDeleteModalProps = {
  open: boolean
  setOpen: (open: boolean) => void
  calendarData?: SalesCalendarListItem
}

export const CalendarDeleteModal = ({ open, setOpen, calendarData }: CalendarDeleteModalProps) => {
  const dispatch = useDispatch()

  const handleClose = () => {
    setOpen(false)
  }

  const handleDeleteCalendar = () => {
    if (calendarData) {
      const params = {
        officeCode: calendarData.officeCode,
        yearMonth: calendarData.yearMonth,
      }
      dispatch(deleteSalesCalendar(params))
      handleClose()
    }
  }

  return (
    <Modal
      actionBadge={
        <Badge appearance="soft" color="warning">
          {t('common.messages.actionCannotBeUndone')}
        </Badge>
      }
      buttonAction={handleDeleteCalendar}
      buttonIcon={<Icon icon="trash" size="18" />}
      buttonText={t('buttons.delete')}
      buttonVariant="danger"
      closeAction={handleClose}
      description={t('screens.salesCalendar.deletePeriodConfirmation')}
      modalWidth={550}
      open={open}
      returnAction={handleClose}
      setOpen={setOpen}
      showAction
      showClose
      showReturn
      title={t('screens.salesCalendar.deletePeriod')}
      titleSize={18}
    />
  )
}
